import React from "react";
import { Typography, Chip } from "@material-ui/core";

export function MappableFieldsInfo({ availableFields, resources, chipClass }) {
	return (
		<div
			style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}
		>
			<Typography variant="caption" color="textSecondary">
				{resources["MappableFieldsInfoCaption"]}
			</Typography>
			<Chip
				size="small"
				label={`${availableFields.length} ${resources["MappableFieldsAvailable"]}`}
				className={chipClass}
				color="primary"
				variant="outlined"
			/>
		</div>
	);
}
